import React, { useState, useEffect } from "react";

import RetrictionsSearchMain from "./RetrictionsSearch";
const defaultAutos = {
  Branches: [],
};

export default function SearchReaceiptContainer(props) {
  const {
    openSearchMdl,  handCloseDw,
    onRowDataClick ,type,AutoOptions, transition,usersSearch} = props;

  return (

    <RetrictionsSearchMain
      {...{
        openSearchMdl,  handCloseDw,
        onRowDataClick ,type,AutoOptions,transition,
        usersSearch
          }}
    />
  );
}
